import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Meals from "../models/meals-model";

interface MealBoxProps {
    mealData: any;
    maxCounter?: number;
    maxReached?: boolean;
    onMealCountIncremented?: (mealCount: Meals) => void;
    onMealCountDecremented?: (mealCount: Meals) => void;
}

interface MealBoxState {
    id: string;
    title: string;
    description: string;
    image: string;
    price_huf: number;
    price_eur: number;
    mealCount: number;
    translations: Record<string, any>;
}

class MealBox extends Component<MealBoxProps, MealBoxState> {
    constructor(props: MealBoxProps) {
        super(props);
        this.state = { 
            id: this.props.mealData.id,
            title: this.props.mealData.title, 
            description: this.props.mealData.description,
            image: this.props.mealData.image,
            price_huf: this.props.mealData.price_huf,
            price_eur: this.props.mealData.price_eur,
            mealCount: 0,
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private decrementMeal() {
        const newMealCount = Math.max(this.state.mealCount - 1, 0);
        this.setState({ mealCount: newMealCount }, () => {
            if (this.props.onMealCountDecremented) {
                const mealData: Meals = {
                    id: this.state.id,
                    title: this.state.title,
                    description: this.state.description,
                    image: this.state.image,
                    price_huf: this.state.price_huf,
                    price_eur: this.state.price_eur,
                    quantity: newMealCount
                };
                this.props.onMealCountDecremented(mealData);
            }
        });
    }

    private incrementMeal() {
        if (this.props.maxReached) {
            return;
        }
        const newMealCount = this.state.mealCount + 1;
        this.setState({ mealCount: newMealCount }, () => {
            if (this.props.onMealCountIncremented) {
                const mealData: Meals = {
                    id: this.state.id,
                    title: this.state.title,
                    description: this.state.description,
                    image: this.state.image,
                    price_huf: this.state.price_huf,
                    price_eur: this.state.price_eur,
                    quantity: newMealCount
                };
                this.props.onMealCountIncremented(mealData);
            }
        });
    }

    checkMaxMealsReached() {
        return this.props.maxCounter !== undefined && this.props.maxCounter === 0;
    }

    render() {
        return (
            <div className="oc-meal-box">
                <Row>
                    <Col lg={5} md={5} sm={12} xs={12}>
                        <figure 
                            className="oc-meal-image" 
                            style={{ backgroundImage: `url(${this.state?.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        </figure>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                        <h2 className="oc-meal-title">{this.state?.title}</h2>
                        <p className="oc-meal-text">{this.state?.description}</p>
                        <p className="oc-meal-price">{this.state.translations.filter((item: any) => item.setting_name === 'ONLY')[0].setting_value_text} {this.state.price_huf} {this.state.translations.filter((item: any) => item.setting_name === 'HUF_PERSON')[0].setting_value_text}.</p>
                        <div className="oc-meal-cart">
                            <Button variant="light" className="oc-btn oc-btn-decrease" onClick={() => {this.decrementMeal()}}>-</Button>
                            <input type="text" className="oc-input oc-input-count" value={this.state.mealCount} readOnly />
                            <Button variant="light" className="oc-btn oc-btn-increase" disabled={this.props.maxReached} onClick={() => {this.incrementMeal()}}>+</Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default MealBox;